import { Component } from "@angular/core";
import { Router } from "@angular/router";
import { DashboardService } from "./dashboard.service";
import { HelperService } from "../../../core/services/helper/helper.service";
import { CommonConstants } from "../../../core/constants/common-constants";
import { debounceTime, Subject, Subscription } from "rxjs";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { TranslocoModule } from "@ngneat/transloco";
import { MatIconModule } from "@angular/material/icon";
import { MatButtonModule } from "@angular/material/button";
import { MatRippleModule } from "@angular/material/core";
import { MatMenuModule } from "@angular/material/menu";
import { MatTabsModule } from "@angular/material/tabs";
import { MatButtonToggleModule } from "@angular/material/button-toggle";
import { CurrencyPipe, NgClass } from "@angular/common";
import { LABELS } from "app/core/constants/label-constants";
import { AccountService } from "../settings/account/account.service";
import { environment } from "../../../../environments/environment.prod"
import { decryptData, encryptData } from "../../../core/services/encryptData/encrypt-data.service";
import { BrandTermPopupComponent } from "app/modules/common/brand-term-popup/brand-term-popup.component";
import { MatDialog } from "@angular/material/dialog";
import { BrandTermsService } from "../brand-terms/brand-terms.service";
import { BrandItemPopupService } from "app/modules/common/brand-term-popup/brand-item-popup.service";

@Component({
  selector: "app-dashboard",
  standalone: true,
  imports: [
    TranslocoModule,
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatMenuModule,
    MatTabsModule,
    MatButtonToggleModule,
    MatTableModule,
    NgClass,
  ],
  providers: [AccountService],
  templateUrl: "./dashboard.component.html",
  styleUrl: "./dashboard.component.scss",
})
export class DashboardComponent {
  clientId: any = environment.clientId;
  redirectUri: any = environment.redirectUri;
  storeUrl: any;
  secret: any;
  data: any;
  adminName = "";
  imagView = "";
  dashboardDataList: any = [];
  query = {
    page: 1,
    limit: "10",
    search: "",
    sortKey: "",
    sortBy: -1,
  };
  total = 0;
  url = "heroicons_outline:photo";
  isPartner: boolean = false;
  pageName: string = LABELS.DASHBOARD;
  sub: any = Subscription;
  partnerUrl: any;
  partnerId: any;
  isConnected: boolean = false;
  storeType: any;
  isShow: boolean = false;
  storeUrlWoo: any;
  clientIdWoo: any;
  secretWoo: any;
  brantTermNotAccepted: any;
  details: any;
  stripeConfigured: any;

  constructor(
    private _router: Router,
    private _apiService: DashboardService,
    private _helper: HelperService,
    private _acService: AccountService,
    private dialog: MatDialog,
    private _brandTermService: BrandTermsService,
    private eventService: BrandItemPopupService
  ) {
    this._helper.pageName.next(this.pageName);
    this.isPartner = this._router.url.indexOf('/partner') !== -1 || window.location.origin.indexOf('partners') !== -1;
    if (this._router.url.indexOf('/partner-management') !== -1) {
      this.isPartner = false;
    }
    if (this.isPartner) {
      this.sub = this._helper.filter$
        .pipe(debounceTime(500))
        .subscribe((res: any) => {
            let brandId = res;
            this.getStatistics({ brandId: brandId });
        });
      this.getDetails();

    } else {
      this.getStatistics();
    }
    this.getAccountDetails();


  }

  getDetails() {
    this._brandTermService.viewActive().subscribe((res: any) => {
      if (res?.meta?.status == 1) {
        this.details = res?.data;

        const brandTermAccepted = localStorage.getItem('brandTermAccepted');
        if (brandTermAccepted === null || brandTermAccepted === 'false') {
          this.brantTermNotAccepted = 'false';
          if (this.details) {
            setTimeout(() => this.openPopup(), 0);
          }
        } else {
          this.brantTermNotAccepted = 'true';
        }
      } else {
        this._helper.toast(res?.meta?.message, 'error');
      }
    });
  }

  configureStripeAccount() {
    this._apiService.stripeConfigure().subscribe((res: any) => {
      if (res?.meta?.status == 1) {
        if (res?.data?.url) {
          window.open(res?.data?.url, "_self");
        }
      } else {
        this._helper.toast(res?.meta?.message, 'error');
      }
    });
  }


  openPopup() {
    const dialogRef = this.dialog.open(BrandTermPopupComponent, {
      width: "1100px",
      data: this.details,
      disableClose: true
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (!result) return;

    })
  }

  ngOnInit() {

    this._helper.setPageTitle(
      'Dashboard',
      'Dashboard'
    );
    this.eventService.trigger$.subscribe(data => {
      this.brantTermNotAccepted = localStorage.getItem("brandTermAccepted")
    });
  }

  /**
   * SUmmary: This methof is use for get user details
   */
  getAccountDetails() {
    this._acService.viewAccount(this.isPartner).subscribe((res: any) => {
      if (res?.meta?.status == 1) {
        this.partnerUrl = res?.data?.partnerUrl;
        this.partnerId = res?.data?.partnerId;
        this.clientId = res?.data?.clientId ? decryptData(res.data.clientId) : '';
        this.secret = res?.data?.secret ? decryptData(res.data.secret) : '';
        this.storeUrl = res?.data?.storeUrl ? res.data.storeUrl : '';

        this.clientIdWoo = res?.data?.clientIdWoo ? decryptData(res.data.clientIdWoo) : '';
        this.secretWoo = res?.data?.secretWoo ? decryptData(res.data.secretWoo) : '';
        this.storeUrlWoo = res?.data?.storeUrlWoo ? res.data.storeUrlWoo : '';

        if ((this.clientId && this.storeUrl) || (this.clientIdWoo && this.storeUrlWoo)) {
          this.isShow = true;
        } else {
          this.isShow = false;
        }
        this.isConnected = res?.data?.isConnected;
        this.storeType = res?.data?.storeType;

        if (this.isPartner) {
          this.stripeConfigured = res?.data?.stripeOnboardingCompleted;
        }
      } else {
      }
    });
  }

  /**
   * Summary: This method is use for get admin data
   */
  getUserData() {
    let user: any;
    user = this._helper.getLocalStorageData(CommonConstants.PARTNER_PROFILE);

    if (user) {
    }
  }

  /**
   * Summary: This method is use for get statistics
   */
  getStatistics(data?: any) {
    this._apiService
      .getData(this.isPartner, data)
      .subscribe(async (data: any) => {
        if (data?.meta?.status === 1) {
          this.dashboardDataList = await data?.data;
        }
      });
  }

  /**
   * Summary: This method is use for redirect user on specific page from dashboard
   * @param data
   * @param name
   */
  redirectToPage(data: any, name?: any) {
    if (!this.isPartner) {
      switch (data) {
        case "Users":
          this._router.navigate(["user-management"]);
          break;
        case "Styles":
          this._router.navigate(["style-management"]);
          break;
        case "Outfits":
          this._router.navigate(["outfit-management"]);
          break;
        case "Brands":
          this._router.navigate(["master-brands"]);
          break;
        case "Wardrobe Categories":
          this._router.navigate(["wardrobe-category-management"]);
          break;
        case "Seasons":
          this._router.navigate(["season-management"]);
          break;
        case "Occasions":
          this._router.navigate(["occasion-management"]);
          break;
        case "Advertises":
          this._router.navigate(["advertise-management"]);
          break;
        case "Marketplace Items":
          this._router.navigate(["vintage-management"]);
          break;
        case "Orders":
          this._router.navigate(["order-management"]);
          break;
        case "Partners":
          this._router.navigate(["partner-management"]);
          break;
      }
    } else {
      switch (data) {
        case "Products":
          environment.production ? (this.isPartner ? this._router.navigate(["my-product-management"]) : this._router.navigate(["product-management"])) : this._router.navigate(["partner/product-management"]);
          break;
        case "Orders":
          environment.production ? this._router.navigate(["order-management"]) : this._router.navigate(["partner/order-management"]);
          break;
      }
    }
  }

  connectToShopify(shop: string, partnerId: any) {
    if (this.clientId && this.storeUrl) {
      this._helper.loader(true, 'Please wait...', 'We are connecting with your Shopify store');
      this._helper.setLocalStorageData("P_ID", partnerId);
      const scopes = [
        "read_products",
        "write_products",
        "read_orders",
        "write_orders",
        "read_invetory",
        "write_invetory"
      ].join(",");
      const oauthUrl = `https://${this.storeUrl}/admin/oauth/authorize?client_id=${this.clientId}&scope=${scopes}&redirect_uri=${this.redirectUri}`;
      this._helper.loader(false);
      window.location.href = oauthUrl;
    } else {
      this._helper.toast('Something went wrong', 'error');
    }
  }

  connectToWoo() {

  }

  protected readonly LABELS = LABELS;
}
